export default __webpack_public_path__ + "static/media/share-social.ebd9f428.png";